export const EstadoAprobacion = {
    PENDIENTE: "PENDIENTE",
    APROBADO: "APROBADO",
    RECHAZADO:"RECHAZADO"
}